import { LocationsActionsTypes } from './actions';

const initialState = {
  locationsForBounds: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LocationsActionsTypes.FETCH_LOCATIONS_FOR_VIEWPORT_SUCCESS:
      return {
        ...state,
        locationsForBounds: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
